import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, } from '@angular/core';
import { AuthService } from '@modules/auth';
import { ModalController, NavController } from '@ionic/angular';
import { NotificationsPage } from '@modules/notifications/notifications.page';
import { NotificationService } from '@modules/notifications/_services';
import { MessagingService } from '@modules/notifications/_services/messaging.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { SubscriptionService } from '@core/_services/subscription/subscription.service';
import { PaymentSubscriptionStatus } from '@core/models/interfaces/subscription.interface';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() initials: string;
  @Input() showBackButton = false;
  userName: string;
  numNotifications: number = 0;
  messageSubscription: Subscription;

  paymentSubscriptionStatus: PaymentSubscriptionStatus;
  protected readonly PaymentSubscriptionStatus = PaymentSubscriptionStatus;

  constructor(
    private authService: AuthService,
    private modalController: ModalController,
    private notificationService: NotificationService,
    private messagingService: MessagingService,
    private cd: ChangeDetectorRef,
    private router: Router,
    private navController: NavController,
    private subscriptionService: SubscriptionService
  ) {
  }

  ngOnDestroy(): void {
    this.messageSubscription.unsubscribe();
  }

  ngOnInit() {
    const currentUser = this.authService.currentUserValue;
    this.initials = currentUser.profile.username[0].toUpperCase();
    this.userName =
      currentUser.profile.first_name + ' ' + currentUser.profile.last_name;
    this.paymentSubscriptionStatus = currentUser.profile.company.subscription.status ?? PaymentSubscriptionStatus.INACTIVE;

    this.reloadBadget();
    this.messageSubscription = this.messagingService.getMessage$.subscribe(
      (changes: any) => {
        if (changes !== null) {
          this.reloadBadget();
        }
      }
    );
  }

  reloadBadget() {
    this.notificationService.getBagdeNotifications().subscribe(
      (response: any) => {
        this.numNotifications = response?.total || 0;
        this.cd.detectChanges();
      },
      () => {
        this.numNotifications = 0;
        this.cd.detectChanges();
      }
    );
  }

  async openNotificationListModal() {
    const modal = await this.modalController.create({
      id: 'NotificationsPage',
      component: NotificationsPage,
      backdropDismiss: false,
      cssClass: 'right-side-modal-css',
    });

    return await modal.present();
  }

  openVideosPage() {
    this.navController.navigateForward(['/tutorial-list']);
  }

  public restartOnBoarding() {
    this.authService.updateProfile(true).subscribe({
      next: () => {
        // Using Angular's Router to navigate home and reload the page
        // This will refresh the application state without direct DOM manipulation
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/home']);
        });
      },
      error: (error) => {
        console.error('Error updating onboarding status:', error);
      }
    });
  }

  onMySubscriptionClick(): void {
    this.subscriptionService.openSubscriptionDialog();
  }

  shouldShowSubscribeButton(): boolean {
    const currentUser = this.authService.currentUserValue;

    const subscription = currentUser.profile?.company?.subscription;
    this.paymentSubscriptionStatus = subscription.status ?? PaymentSubscriptionStatus.INACTIVE;

    if (!subscription.valid_until) {
      // Si no hay fecha de validez, asumimos que la suscripción es inactiva
      return true;
    }

    const validUntilDate = new Date(subscription.valid_until);
    const currentDate = new Date();

    // Calculate the number of days remaining until the expiration date
    const timeDiff = validUntilDate.getTime() - currentDate.getTime();
    const daysRemaining = Math.ceil(timeDiff / (1000 * 3600 * 24));

    // Show the subscribe button if 5 or fewer days remain OR the date has already passed
    return (subscription.status === PaymentSubscriptionStatus.INACTIVE || subscription.status === PaymentSubscriptionStatus.TRIAL)
      && (daysRemaining <= 5 || timeDiff <= 0);
  }
}
